function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement?.parentElement?.querySelector('.loading__spinner');
  if (!loadingSpinner) return;
  loadingSpinner.classList.toggle('hidden');
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.currentSrc || image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function moveWithHover(image, overlay, event, zoomRatio) {
  const media = image.closest('.product__media') || image.parentElement;
  if (!media) return;

  const rect = media.getBoundingClientRect();
  const xPosition = event.clientX - rect.left;
  const yPosition = event.clientY - rect.top;
  const xPercent = `${(xPosition / rect.width) * 100}%`;
  const yPercent = `${(yPosition / rect.height) * 100}%`;

  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  const baseWidth = image.naturalWidth || image.width || image.clientWidth;
  overlay.style.backgroundSize = `${baseWidth * zoomRatio}px`;
}

function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.currentSrc || image.src}`);
  const overlay = document.createElement('div');
  prepareOverlay(overlay, image);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
    if (overlay.dataset.vtPendingEvent === 'true' && overlay._vtPendingPointerEvent) {
      moveWithHover(image, overlay, overlay._vtPendingPointerEvent, overlay._vtZoomRatio);
      delete overlay._vtPendingPointerEvent;
      delete overlay.dataset.vtPendingEvent;
    }
  };

  overlayImage.onerror = () => {
    toggleLoadingSpinner(image);
    image.style.opacity = '100%';
  };

  return overlay;
}

function magnify(image, zoomRatio, pointerEvent) {
  const existingOverlay = image.parentElement?.querySelector('.image-magnify-full-size');
  if (existingOverlay) {
    existingOverlay.remove();
    return;
  }

  const overlay = createOverlay(image);
  overlay._vtZoomRatio = zoomRatio;
  if (pointerEvent) {
    overlay.dataset.vtPendingEvent = 'true';
    overlay._vtPendingPointerEvent = pointerEvent;
  }

  overlay.onclick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    overlay.remove();
  };

  overlay.onmousemove = (event) => moveWithHover(image, overlay, event, zoomRatio);
  overlay.onmouseleave = () => overlay.remove();
  overlay.ontouchmove = (event) => {
    if (!event.touches?.length) return;
    moveWithHover(image, overlay, event.touches[0], zoomRatio);
  };
  overlay.ontouchend = () => overlay.remove();
}

function enableZoomOnHover(zoomRatio) {
  document.querySelectorAll('.image-magnify-hover').forEach((image) => {
    if (image.dataset.vtZoomBound === 'true') return;
    image.dataset.vtZoomBound = 'true';

    image.addEventListener('click', (event) => {
      if (!image.closest('.product__media-item.is-active, .product-media-modal__content')) return;
      if (image.closest('.product-media-modal__content')) return;

      event.preventDefault();
      event.stopPropagation();
      magnify(image, zoomRatio, event);
    });
  });
}

window.enableZoomOnHover = enableZoomOnHover;

enableZoomOnHover(2);
